import { Banner } from '@neo4j-ndl/react';
import type { ComponentProps } from 'react';

import classes from './form-banner.module.css';

export const FormBanner = (props: ComponentProps<typeof Banner>) => {
  return <Banner {...props} className={classes.banner} usage="inline" />;
};
